import { NamedDefinitionPage } from './NamedDefinitionPage';

export function CustomerGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/customergroups"
      listRoute="/customer-groups"
      title="Müşteri Grubu Yönetimi"
      subtitle="Müşteri grubu kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Grup Kodu"
      descriptionLabel="Açıklama"
      newLabel="Yeni Müşteri Grubu"
    />
  );
}
